module.exports = __webpack_public_path__ + "static/img/customers.b20b92d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/casePage/customers.png
// module id = KsWh
// module chunks = 0